/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Wc_Dl_Mac_S3Inputs */

const en_wc_dl_mac_s3 = /** @type {(inputs: Wc_Dl_Mac_S3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Launch it from Applications. If macOS warns about the app, Control-click it and choose Open, or allow it in System Settings → Privacy & Security.`)
};

/**
* | output |
* | --- |
* | "Launch it from Applications. If macOS warns about the app, Control-click it and choose Open, or allow it in System Settings → Privacy & Security." |
*
* @param {Wc_Dl_Mac_S3Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const wc_dl_mac_s3 = /** @type {((inputs?: Wc_Dl_Mac_S3Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Wc_Dl_Mac_S3Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_wc_dl_mac_s3(inputs)
});
export { wc_dl_mac_s3 as "wc.dl.mac.s3" }